import { Pagination } from 'react-admin';

export const ListPagination = () => <Pagination rowsPerPageOptions={[10, 20, 30, 50]} />;